export const UserAccountType = {
    Single: 1,
    Shared: 2
}